(function () {
  'use strict';

  /* ═══════════════════════════════════════════════
     CONFIG — matched to XYControlArea.cpp
     ═══════════════════════════════════════════════ */

  var SPRING_CFG = [
    { k: 0.20, d: 1.13, m: 1.6  },   // 0  cursor (overdamped)
    { k: 0.09, d: 0.88, m: 3.8  },   // 1  inner glow
    { k: 0.07, d: 0.85, m: 5.2  },   // 2  mid glow
    { k: 0.05, d: 0.82, m: 6.8  },   // 3  outer glow
    { k: 0.04, d: 0.78, m: 8.5  },   // 4  ambient
    { k: 0.03, d: 0.75, m: 10.5 }    // 5  atmosphere
  ];

  var GLOW_SIZES    = [200, 320, 460, 620, 800];
  var GLOW_OPAC     = [0.95, 0.80, 0.65, 0.50, 0.40];
  var REF_SIZE      = 316;   // plugin defaultSize(368) - padding(52)
  var GLOW_RES      = 256;
  var BG_RES        = 64;
  var GOLDEN_ANGLE  = 2.39996;

  var PRESETS = {
    blue: {
      baseBg:  [255, 255, 255], tint: [40, 104, 216],
      cursor:  [255, 255, 255],
      glowIn:  [80, 150, 240],  glowOut: [190, 215, 255],
      repul:   [255, 255, 255]
    },
    red: {
      baseBg:  [255, 0, 0],     tint: [106, 10, 10],
      cursor:  [255, 70, 50],
      glowIn:  [0, 0, 0],       glowOut: [50, 0, 0],
      repul:   [255, 0, 0]
    },
    black: {
      baseBg:  [0, 0, 0],       tint: [26, 0, 48],
      cursor:  [0, 0, 0],
      glowIn:  [255, 255, 255], glowOut: [200, 200, 240],
      repul:   [40, 24, 80]
    }
  };

  /* ═══════════════════════════════════════════════
     STATE
     ═══════════════════════════════════════════════ */

  var springs = SPRING_CFG.map(function (c) {
    return { x: 0.5, y: 0.5, vx: 0, vy: 0, k: c.k, d: c.d, m: c.m };
  });

  var targetX = 0.5, targetY = 0.5;
  var isBreathing = true, breatheTime = 0, breatheBlend = 0;
  var idleTimer = 600;
  var isDispersing = false, disperseTime = 0;
  var preset = 'blue';
  var lastTime = 0;
  var transitioned = false;
  var animating = true;

  // Reactive background blobs
  var blobs = [];
  var rTime = 0;

  // Canvas
  var canvas, ctx, bgCanvas, bgCtx;
  var padSize = 420, dpr = 1;

  // Pre-rendered glow images
  var glowCache = {};

  /* ═══════════════════════════════════════════════
     INIT
     ═══════════════════════════════════════════════ */

  function init() {
    canvas = document.getElementById('f8-canvas');
    if (!canvas) return;
    ctx = canvas.getContext('2d');

    bgCanvas = document.createElement('canvas');
    bgCanvas.width = BG_RES;
    bgCanvas.height = BG_RES;
    bgCtx = bgCanvas.getContext('2d');

    initBlobs();
    buildGlows();
    resize();

    window.addEventListener('resize', resize);
    bindInput();
    prefetchAudio();
    var audioBtn = document.getElementById('f8-audio-btn');
    if (audioBtn) audioBtn.addEventListener('click', toggleAudio);
    initTaglines();
    requestAnimationFrame(loop);
  }

  /* ── Blobs (golden-angle spiral, same as plugin) ── */
  function initBlobs() {
    for (var i = 0; i < 8; i++) {
      var fi = i;
      var r = 0.30 + 0.18 * (fi / 7);
      var a = fi * GOLDEN_ANGLE;
      blobs.push({
        bx: 0.5 + r * Math.cos(a),
        by: 0.5 + r * Math.sin(a),
        wpx: fi * 1.618, wpy: fi * 2.414,
        wsx: 0.5 + fi * 0.10, wsy: 0.4 + fi * 0.12,
        wr: 0.08 + fi * 0.015,
        rad: 0.60 + fi * (0.35 / 7),
        sUp: 0.35 - fi * (0.27 / 7),
        sDn: 0.08 - fi * (0.04 / 7),
        int: 0.06 + fi * (0.04 / 7),
        aud: 0.0
      });
    }
  }

  /* ── Pre-render glow radial gradient per preset ── */
  function buildGlows() {
    var s = GLOW_RES, cx = s / 2;
    for (var name in PRESETS) {
      var p = PRESETS[name];
      var c = document.createElement('canvas');
      c.width = s; c.height = s;
      var g = c.getContext('2d');
      var grad = g.createRadialGradient(cx, cx, 0, cx, cx, cx);
      var ri = p.glowIn, ro = p.glowOut;
      grad.addColorStop(0,    rgba(ri, 1));
      grad.addColorStop(0.20, rgba(ri, 0.75));
      grad.addColorStop(0.40, rgba(mid(ri, ro), 0.45));
      grad.addColorStop(0.65, rgba(ro, 0.15));
      grad.addColorStop(1,    rgba(ro, 0));
      g.fillStyle = grad;
      g.fillRect(0, 0, s, s);
      glowCache[name] = c;
    }
  }

  function rgba(c, a) { return 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + a + ')'; }
  function mid(a, b) { return [Math.round((a[0]+b[0])/2), Math.round((a[1]+b[1])/2), Math.round((a[2]+b[2])/2)]; }

  /* ── Resize ── */
  function resize() {
    dpr = window.devicePixelRatio || 1;
    var maxW = window.innerWidth - 48;
    var maxH = window.innerHeight * 0.48;
    padSize = Math.max(260, Math.min(420, maxW, maxH));

    canvas.width  = padSize * dpr;
    canvas.height = padSize * dpr;
    canvas.style.width  = padSize + 'px';
    canvas.style.height = padSize + 'px';
  }

  /* ═══════════════════════════════════════════════
     INPUT
     ═══════════════════════════════════════════════ */

  function bindInput() {
    var rect = function () { return canvas.getBoundingClientRect(); };

    function wake() {
      isBreathing = false;
      breatheBlend = 0;
      idleTimer = 0;
    }

    /* Hover */
    canvas.addEventListener('mousemove', function (e) {
      if (transitioned) return;
      var r = rect();
      targetX = clamp((e.clientX - r.left) / r.width);
      targetY = clamp((e.clientY - r.top) / r.height);
      wake();
    });

    canvas.addEventListener('mouseleave', function () {
      if (transitioned) return;
      targetX = 0.5; targetY = 0.5;
      idleTimer = 0;
    });

    /* Double-click */
    canvas.addEventListener('dblclick', function (e) {
      e.preventDefault();
      if (transitioned) return;
      triggerTransition();
    });

    /* Touch */
    canvas.addEventListener('touchstart', function (e) {
      e.preventDefault();
      if (transitioned) return;
      var t = e.touches[0], r = rect();
      targetX = clamp((t.clientX - r.left) / r.width);
      targetY = clamp((t.clientY - r.top) / r.height);
      wake();
    }, { passive: false });

    canvas.addEventListener('touchmove', function (e) {
      e.preventDefault();
      if (transitioned) return;
      var t = e.touches[0], r = rect();
      targetX = clamp((t.clientX - r.left) / r.width);
      targetY = clamp((t.clientY - r.top) / r.height);
    }, { passive: false });

    /* Double-tap */
    var lastTap = 0;
    canvas.addEventListener('touchend', function () {
      var now = Date.now();
      if (now - lastTap < 300 && !transitioned) triggerTransition();
      lastTap = now;
      targetX = 0.5; targetY = 0.5; idleTimer = 0;
    });
  }

  function clamp(v) { return Math.max(0, Math.min(1, v)); }

  /* ═══════════════════════════════════════════════
     DISPERSE + PAGE TRANSITION
     ═══════════════════════════════════════════════ */

  function triggerTransition() {
    /* Fade out audio demo */
    fadeOutAudio();

    /* Disperse effect */
    isDispersing = true;
    disperseTime = 0;
    isBreathing = false;
    breatheBlend = 0;

    var base = Math.random() * Math.PI * 2;
    for (var i = 1; i < springs.length; i++) {
      var angle = base + (i - 1) * GOLDEN_ANGLE;
      var impulse = 0.08 + i * 0.025;
      springs[i].vx += Math.cos(angle) * impulse;
      springs[i].vy += Math.sin(angle) * impulse;
    }

    transitioned = true;
    var promptEl = document.getElementById('f8-prompt');
    if (promptEl) promptEl.classList.add('interacted');

    /* Phase out hero, phase in flow */
    setTimeout(function () {
      /* Pre-compensate for scrollbar width before it appears */
      var scrollW = window.innerWidth - document.documentElement.clientWidth;
      if (scrollW <= 0) {
        document.body.classList.remove('f8-locked');
        scrollW = window.innerWidth - document.documentElement.clientWidth;
        document.body.classList.add('f8-locked');
      }
      document.body.style.paddingRight = scrollW + 'px';

      var hero = document.getElementById('f8-hero');
      if (hero) hero.classList.add('fade-out');

      setTimeout(function () {
        document.body.classList.remove('f8-locked');
        document.body.style.paddingRight = '';
        var flow = document.getElementById('f8-flow');
        if (flow) flow.classList.add('visible');
        initScrollReveal();

        /* Stop canvas after transition completes */
        setTimeout(function () { animating = false; }, 1500);
      }, 500);
    }, 700);
  }

  function initScrollReveal() {
    var els = document.querySelectorAll('.f8-reveal');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add('visible');
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { obs.observe(el); });

    /* Floating scroll arrow */
    var arrow = document.getElementById('f8-scroll-arrow');
    if (!arrow) return;

    var sections = Array.prototype.slice.call(
      document.querySelectorAll('#f8-flow .f8-section')
    );

    arrow.classList.add('visible');

    arrow.addEventListener('click', function () {
      var scrollY = window.scrollY || window.pageYOffset;
      var vh = window.innerHeight;
      var next = null;
      for (var i = 0; i < sections.length; i++) {
        var top = sections[i].getBoundingClientRect().top + scrollY;
        if (top > scrollY + vh * 0.3) {
          next = sections[i];
          break;
        }
      }
      if (next) {
        next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    /* Hide arrow near the bottom (buy section / footer) */
    window.addEventListener('scroll', function () {
      var distFromBottom = document.documentElement.scrollHeight - window.scrollY - window.innerHeight;
      if (distFromBottom < 300) {
        arrow.classList.add('hidden');
      } else {
        arrow.classList.remove('hidden');
      }
    }, { passive: true });
  }

  /* ═══════════════════════════════════════════════
     SPRING PHYSICS
     ═══════════════════════════════════════════════ */

  function stepSpring(s, tx, ty, dt) {
    var fx = (tx - s.x) * s.k;
    var fy = (ty - s.y) * s.k;
    s.vx += (fx - s.vx * s.d) / s.m * dt;
    s.vy += (fy - s.vy * s.d) / s.m * dt;
    s.x += s.vx * dt;
    s.y += s.vy * dt;

    if (Math.abs(s.vx) < 0.0005) s.vx *= 0.98;
    if (Math.abs(s.vy) < 0.0005) s.vy *= 0.98;
    if (Math.abs(s.vx) < 0.00001) s.vx = 0;
    if (Math.abs(s.vy) < 0.00001) s.vy = 0;
  }

  /* ═══════════════════════════════════════════════
     REACTIVE BACKGROUND
     ═══════════════════════════════════════════════ */

  function updateBg() {
    var p = PRESETS[preset];
    var bR = p.baseBg[0], bG = p.baseBg[1], bB = p.baseBg[2];
    var tR = p.tint[0],   tG = p.tint[1],   tB = p.tint[2];

    // Simulated ambient audio pulse — subtle so white base dominates
    var sim = 0.03 + 0.02 * Math.sin(rTime * 0.4) + 0.01 * Math.sin(rTime * 1.1);
    for (var b = 0; b < blobs.length; b++) {
      var bl = blobs[b];
      var coeff = (sim > bl.aud) ? bl.sUp : bl.sDn;
      bl.aud += coeff * (sim - bl.aud);
    }
    rTime += 1 / 60;

    // Global base influence
    var gBase = 0;
    for (b = 0; b < blobs.length; b++) gBase += blobs[b].aud * blobs[b].int;
    gBase = (gBase / blobs.length) * 0.4;

    var imgData = bgCtx.createImageData(BG_RES, BG_RES);
    var d = imgData.data;
    var cx = springs[0].x, cy = springs[0].y;

    for (var py = 0; py < BG_RES; py++) {
      var ny = py / (BG_RES - 1);
      for (var px = 0; px < BG_RES; px++) {
        var nx = px / (BG_RES - 1);
        var inf = gBase;

        for (b = 0; b < blobs.length; b++) {
          var bl2 = blobs[b];
          var bx = cx + (bl2.bx - 0.5) + bl2.wr * Math.sin(rTime * bl2.wsx + bl2.wpx);
          var by = cy + (bl2.by - 0.5) + bl2.wr * Math.cos(rTime * bl2.wsy + bl2.wpy);
          var dx = nx - bx, dy = ny - by;
          var dSq = dx * dx + dy * dy;
          var rSq = bl2.rad * bl2.rad;
          if (dSq < rSq) {
            var t = dSq / rSq;
            inf += (1 - t * t * (3 - 2 * t)) * bl2.aud * bl2.int;
          }
        }

        if (inf < 0.06) inf = 0.06;
        if (inf > 1) inf = 1;
        var idx = (py * BG_RES + px) * 4;
        d[idx]     = bR + (tR - bR) * inf;
        d[idx + 1] = bG + (tG - bG) * inf;
        d[idx + 2] = bB + (tB - bB) * inf;
        d[idx + 3] = 255;
      }
    }
    bgCtx.putImageData(imgData, 0, 0);
  }

  /* ═══════════════════════════════════════════════
     DRAW
     ═══════════════════════════════════════════════ */

  function draw() {
    var s = padSize;
    var ws = s / REF_SIZE;
    var half = GLOW_RES / 2;
    var glowImg = glowCache[preset];
    var p = PRESETS[preset];

    ctx.save();
    ctx.scale(dpr, dpr);
    ctx.clearRect(0, 0, s, s);

    // Reactive background (64×64 → padSize) — CSS border-radius handles corner clipping
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(bgCanvas, 0, 0, s, s);

    // Glow layers back → front
    for (var i = 4; i >= 0; i--) {
      var sp = springs[i + 1];
      var px = sp.x * s;
      var py = sp.y * s;
      var layerSize = GLOW_SIZES[i] * ws;
      var drawScale = layerSize / GLOW_RES;

      var scaleX = 1, scaleY = 1;
      var offX = 0, offY = 0, rot = 0;
      var opacity = GLOW_OPAC[i];

      // Motion deformation
      var speed = Math.sqrt(sp.vx * sp.vx + sp.vy * sp.vy);
      if (speed > 1e-4) {
        rot = Math.atan2(sp.vy, sp.vx);
        var sf = 1 - Math.exp(-speed * 8);
        var sm = 1 + i * 0.3;
        scaleX = 1 + sf * (1.2 + sm);
        scaleY = 1 / (1 + sf * (0.5 + i * 0.1));
        var oa = -sf * (15 + i * 8);
        offX = Math.cos(rot) * oa;
        offY = Math.sin(rot) * oa;
      }

      // Breathing blend
      if (isBreathing && breatheBlend > 0) {
        var phase = breatheTime + i * 0.3;
        var bSc = 1 + 0.08 * Math.sin(phase);
        var bOp = 0.85 + 0.15 * (0.5 + 0.5 * Math.sin(phase));
        var inv = 1 - breatheBlend;
        scaleX = scaleX * inv + bSc * breatheBlend;
        scaleY = scaleY * inv + bSc * breatheBlend;
        opacity = opacity * inv + (GLOW_OPAC[i] * bOp) * breatheBlend;
        rot *= inv;
        offX *= inv;
        offY *= inv;
      }

      ctx.save();
      ctx.globalAlpha = opacity;
      ctx.translate(px + offX, py + offY);
      ctx.rotate(rot);
      ctx.scale(drawScale * scaleX, drawScale * scaleY);
      ctx.drawImage(glowImg, -half, -half);
      ctx.restore();
    }

    // Cursor dot
    ctx.globalAlpha = 1;
    var cX = springs[0].x * s;
    var cY = springs[0].y * s;
    var cR = 9 * ws;
    var cc = p.cursor;
    ctx.fillStyle = 'rgb(' + cc[0] + ',' + cc[1] + ',' + cc[2] + ')';
    ctx.beginPath();
    ctx.arc(cX, cY, cR, 0, Math.PI * 2);
    ctx.fill();

    ctx.restore();
  }

  /* roundRect polyfill */
  function roundRectPath(c, x, y, w, h, r) {
    c.moveTo(x + r, y);
    c.lineTo(x + w - r, y);
    c.quadraticCurveTo(x + w, y, x + w, y + r);
    c.lineTo(x + w, y + h - r);
    c.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    c.lineTo(x + r, y + h);
    c.quadraticCurveTo(x, y + h, x, y + h - r);
    c.lineTo(x, y + r);
    c.quadraticCurveTo(x, y, x + r, y);
    c.closePath();
  }

  /* ═══════════════════════════════════════════════
     MAIN LOOP
     ═══════════════════════════════════════════════ */

  function loop(time) {
    if (!animating) return;

    if (!lastTime) lastTime = time;
    var dtMs = Math.min(time - lastTime, 33.33);
    var dt = dtMs / 16.67;
    lastTime = time;

    /* Update springs */
    stepSpring(springs[0], targetX, targetY, dt);
    for (var i = 1; i < springs.length; i++) {
      stepSpring(springs[i], springs[0].x, springs[0].y, dt);
    }

    /* Disperse timer */
    if (isDispersing) {
      disperseTime += dtMs;
      if (disperseTime > 500) isDispersing = false;
    }

    /* Idle detection */
    var tVel = Math.abs(springs[0].vx) + Math.abs(springs[0].vy);
    var bVel = 0;
    for (i = 1; i < springs.length; i++) bVel += Math.abs(springs[i].vx) + Math.abs(springs[i].vy);

    if (tVel < 0.001 && bVel < 0.01 && !isDispersing) {
      idleTimer += dtMs;
      if (idleTimer > 500 && !isBreathing) {
        breatheTime = 0;
        breatheBlend = 0;
        isBreathing = true;
      }
    } else {
      idleTimer = 0;
      isBreathing = false;
    }

    /* Breathing */
    if (isBreathing) {
      breatheTime += 0.025;
      breatheBlend = Math.min(1, breatheBlend + 0.015);
    } else {
      breatheBlend = Math.max(0, breatheBlend - 0.08);
    }

    updateAudioMix();
    updateBg();
    draw();
    requestAnimationFrame(loop);
  }

  /* ═══════════════════════════════════════════════
     WEB AUDIO DEMO — interactive effect rack
     ═══════════════════════════════════════════════ */

  var audioCtx = null;
  var audioBuffer = null;
  var audioSource = null;
  var audioRawData = null;
  var audioPlaying = false;
  var audioMuted = false;

  // Audio graph nodes
  var aMaster, aDry, aRackXWet, aRackYWet;
  var aDelay, aDelayFb, aDelayLPF;
  var aReverb, aReverbLPF;

  function prefetchAudio() {
    var url = canvas && canvas.getAttribute('data-demo-loop');
    if (!url) return;

    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'arraybuffer';
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        audioRawData = xhr.response;
        var btn = document.getElementById('f8-audio-btn');
        if (btn) btn.classList.add('visible');
      }
    };
    xhr.send();
  }

  function buildAudioGraph() {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();

    // Master output (starts at 0, fades in)
    aMaster = audioCtx.createGain();
    aMaster.gain.value = 0;
    aMaster.connect(audioCtx.destination);

    // Dry path
    aDry = audioCtx.createGain();
    aDry.gain.value = 1.0;
    aDry.connect(aMaster);

    // --- Rack X: Delay ---
    aRackXWet = audioCtx.createGain();
    aRackXWet.gain.value = 0;
    aRackXWet.connect(aMaster);

    aDelay = audioCtx.createDelay(2.0);
    aDelay.delayTime.value = 60 / 107 * 0.75; // dotted eighth at 107 BPM

    aDelayFb = audioCtx.createGain();
    aDelayFb.gain.value = 0.40;

    aDelayLPF = audioCtx.createBiquadFilter();
    aDelayLPF.type = 'lowpass';
    aDelayLPF.frequency.value = 2800;

    // Delay feedback loop: delay → LPF → feedback gain → delay
    aDelay.connect(aDelayLPF);
    aDelayLPF.connect(aDelayFb);
    aDelayFb.connect(aDelay);
    aDelay.connect(aRackXWet);

    // --- Rack Y: Reverb ---
    aRackYWet = audioCtx.createGain();
    aRackYWet.gain.value = 0;
    aRackYWet.connect(aMaster);

    aReverb = audioCtx.createConvolver();
    aReverb.buffer = makeIR(audioCtx, 6.0, 1.0);

    aReverbLPF = audioCtx.createBiquadFilter();
    aReverbLPF.type = 'lowpass';
    aReverbLPF.frequency.value = 8000;

    aReverb.connect(aReverbLPF);
    aReverbLPF.connect(aRackYWet);
  }

  /* Generate impulse response for convolution reverb */
  function makeIR(ctx, dur, decay) {
    var rate = ctx.sampleRate;
    var len = Math.floor(rate * dur);
    var buf = ctx.createBuffer(2, len, rate);
    var L = buf.getChannelData(0);
    var R = buf.getChannelData(1);
    for (var i = 0; i < len; i++) {
      var t = i / rate;
      var env = Math.exp(-t * decay);
      var early = t < 0.12 ? (1 - t / 0.12) * 0.5 : 0;
      L[i] = ((Math.random() * 2 - 1) * env + early * (Math.random() * 2 - 1)) * 0.6;
      R[i] = ((Math.random() * 2 - 1) * env + early * (Math.random() * 2 - 1)) * 0.6;
    }
    return buf;
  }

  function startAudioPlayback() {
    if (audioPlaying || !audioRawData) return;
    if (!audioCtx) buildAudioGraph();
    if (audioCtx.state === 'suspended') audioCtx.resume();

    audioCtx.decodeAudioData(audioRawData.slice(0), function (buffer) {
      audioBuffer = buffer;
      audioSource = audioCtx.createBufferSource();
      audioSource.buffer = buffer;
      audioSource.loop = true;

      // Source → dry + both effect racks
      audioSource.connect(aDry);
      audioSource.connect(aDelay);
      audioSource.connect(aReverb);

      audioSource.start(0);
      audioPlaying = true;

      // Smooth fade in
      aMaster.gain.setValueAtTime(0, audioCtx.currentTime);
      aMaster.gain.linearRampToValueAtTime(0.7, audioCtx.currentTime + 0.5);
    });
  }

  function toggleAudio() {
    var btn = document.getElementById('f8-audio-btn');
    if (!btn) return;

    if (!audioPlaying) {
      startAudioPlayback();
      btn.classList.add('active');
      return;
    }

    audioMuted = !audioMuted;
    if (aMaster && audioCtx) {
      aMaster.gain.setValueAtTime(aMaster.gain.value, audioCtx.currentTime);
      aMaster.gain.linearRampToValueAtTime(audioMuted ? 0 : 0.7, audioCtx.currentTime + 0.15);
    }
    btn.classList.toggle('active', !audioMuted);
  }

  /* Called every frame from main loop — maps cursor position to wet/dry */
  function updateAudioMix() {
    if (!audioPlaying || !audioCtx || audioCtx.state !== 'running') return;

    var x = springs[0].x;         // 0 (left) → 1 (right)
    var y = 1 - springs[0].y;     // invert: top of pad → 1

    // Quadratic curve for natural feel
    var xWet = x * x;
    var yWet = y * y;

    aRackXWet.gain.value = xWet * 0.6;
    aRackYWet.gain.value = yWet * 2.5;

    // Dry fades significantly as reverb increases — drone/pad at full Y
    aDry.gain.value = Math.max(0.15, 1.0 - (xWet * 0.25 + yWet * 0.7));
  }

  function fadeOutAudio() {
    if (!audioCtx || !aMaster || !audioPlaying) return;
    aMaster.gain.setValueAtTime(aMaster.gain.value, audioCtx.currentTime);
    aMaster.gain.linearRampToValueAtTime(0, audioCtx.currentTime + 1.5);
    setTimeout(function () {
      try { if (audioSource) audioSource.stop(); } catch (e) {}
      try { if (audioCtx) audioCtx.close(); } catch (e) {}
      audioPlaying = false;
    }, 1800);
  }

  /* ═══════════════════════════════════════════════
     SHOWCASE — auto-cycling XY pad above Buy Now
     ═══════════════════════════════════════════════ */

  var scCanvas, scCtx, scBgCanvas, scBgCtx;
  var scSprings, scBlobs, scRTime = 0;
  var scPadSize = 320, scDpr = 1;
  var scAnimating = false, scLastTime = 0;

  // Auto-pilot state
  var scTargetX = 0.5, scTargetY = 0.5;
  var scWaypointX = 0.5, scWaypointY = 0.5;
  var scWaypointTimer = 0;
  var scBreathing = true, scBreatheTime = 0, scBreatheBlend = 0;

  // Preset cycling with crossfade
  var SC_PRESETS = ['blue', 'red', 'black'];
  var scCurrentIdx = 0;
  var scPresetTimer = 0;
  var SC_HOLD_DURATION = 2500;    // ms hold on each preset
  var SC_FADE_DURATION = 1200;    // ms crossfade between presets
  var scPhase = 'hold';           // 'hold' or 'fade'
  var scFadeProgress = 0;         // 0 = fully current, 1 = fully next

  function initShowcase() {
    scCanvas = document.getElementById('f8-showcase');
    if (!scCanvas) return;
    scCtx = scCanvas.getContext('2d');

    scBgCanvas = document.createElement('canvas');
    scBgCanvas.width = BG_RES;
    scBgCanvas.height = BG_RES;
    scBgCtx = scBgCanvas.getContext('2d');

    // Independent springs
    scSprings = SPRING_CFG.map(function (c) {
      return { x: 0.5, y: 0.5, vx: 0, vy: 0, k: c.k, d: c.d, m: c.m };
    });

    // Independent blobs
    scBlobs = [];
    for (var i = 0; i < 8; i++) {
      var fi = i;
      var r = 0.30 + 0.18 * (fi / 7);
      var a = fi * GOLDEN_ANGLE;
      scBlobs.push({
        bx: 0.5 + r * Math.cos(a),
        by: 0.5 + r * Math.sin(a),
        wpx: fi * 1.618, wpy: fi * 2.414,
        wsx: 0.5 + fi * 0.10, wsy: 0.4 + fi * 0.12,
        wr: 0.08 + fi * 0.015,
        rad: 0.60 + fi * (0.35 / 7),
        sUp: 0.35 - fi * (0.27 / 7),
        sDn: 0.08 - fi * (0.04 / 7),
        int: 0.06 + fi * (0.04 / 7),
        aud: 0.0
      });
    }

    resizeShowcase();
    window.addEventListener('resize', resizeShowcase);

    // Start only when visible
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !scAnimating) {
          scAnimating = true;
          scLastTime = 0;
          requestAnimationFrame(scLoop);
        } else if (!entry.isIntersecting) {
          scAnimating = false;
        }
      });
    }, { threshold: 0.05 });
    obs.observe(scCanvas);
  }

  /* ═══════════════════════════════════════════════
     TAGLINES — synced to showcase preset cycle
     ═══════════════════════════════════════════════ */

  var TAGLINES = [
    'This is F8.',
    'One interface. Infinite sounds.',
    'The happy accident machine.',
    'Double-click. New sound.',
    'No two clicks alike.',
    'Over 1 quadrillion possibilities.',
    'Let F8 decide.'
  ];
  var taglineEls = [];
  var taglineIdx = 0;
  var taglineCycleTime = 5000; // rotate every 5s

  function initTaglines() {
    var wrapper = document.getElementById('f8-tagline');
    if (!wrapper) return;
    for (var i = 0; i < TAGLINES.length; i++) {
      var p = document.createElement('p');
      p.className = 'f8-tagline';
      p.textContent = TAGLINES[i];
      wrapper.appendChild(p);
      taglineEls.push(p);
    }
    // Show first with fade in
    taglineEls[0].classList.add('fade-in');

    setInterval(function () {
      var current = taglineEls[taglineIdx];
      // Fade out current
      current.classList.remove('fade-in');
      current.classList.add('fade-out');

      // After fade-out completes, swap to next
      setTimeout(function () {
        current.classList.remove('fade-out');
        current.style.opacity = '0';
        taglineIdx = (taglineIdx + 1) % TAGLINES.length;
        var next = taglineEls[taglineIdx];
        next.style.opacity = '';
        next.classList.add('fade-in');
      }, 600);
    }, taglineCycleTime);
  }

  function resizeShowcase() {
    if (!scCanvas) return;
    scDpr = window.devicePixelRatio || 1;
    var maxW = Math.min(360, window.innerWidth - 48);
    scPadSize = Math.max(240, maxW);
    scCanvas.width = scPadSize * scDpr;
    scCanvas.height = scPadSize * scDpr;
    scCanvas.style.width = scPadSize + 'px';
    scCanvas.style.height = scPadSize + 'px';
  }

  /* Interpolate between two preset color arrays */
  function lerpColor(a, b, t) {
    return [
      Math.round(a[0] + (b[0] - a[0]) * t),
      Math.round(a[1] + (b[1] - a[1]) * t),
      Math.round(a[2] + (b[2] - a[2]) * t)
    ];
  }

  function getBlendedPreset() {
    var curName = SC_PRESETS[scCurrentIdx];
    if (scPhase === 'hold' || scFadeProgress <= 0) return PRESETS[curName];
    var nextIdx = (scCurrentIdx + 1) % SC_PRESETS.length;
    var nextName = SC_PRESETS[nextIdx];
    var from = PRESETS[curName];
    var to = PRESETS[nextName];
    var t = scFadeProgress;
    return {
      baseBg:  lerpColor(from.baseBg, to.baseBg, t),
      tint:    lerpColor(from.tint, to.tint, t),
      cursor:  lerpColor(from.cursor, to.cursor, t),
      glowIn:  lerpColor(from.glowIn, to.glowIn, t),
      glowOut: lerpColor(from.glowOut, to.glowOut, t),
      repul:   lerpColor(from.repul, to.repul, t)
    };
  }

  /* Build a temporary glow image from blended colors */
  var scGlowCanvas = null;
  function buildBlendedGlow(p) {
    if (!scGlowCanvas) {
      scGlowCanvas = document.createElement('canvas');
      scGlowCanvas.width = GLOW_RES;
      scGlowCanvas.height = GLOW_RES;
    }
    var s = GLOW_RES, cx = s / 2;
    var g = scGlowCanvas.getContext('2d');
    g.clearRect(0, 0, s, s);
    var grad = g.createRadialGradient(cx, cx, 0, cx, cx, cx);
    var ri = p.glowIn, ro = p.glowOut;
    grad.addColorStop(0,    rgba(ri, 1));
    grad.addColorStop(0.20, rgba(ri, 0.75));
    grad.addColorStop(0.40, rgba(mid(ri, ro), 0.45));
    grad.addColorStop(0.65, rgba(ro, 0.15));
    grad.addColorStop(1,    rgba(ro, 0));
    g.fillStyle = grad;
    g.fillRect(0, 0, s, s);
    return scGlowCanvas;
  }

  /* Auto-pilot: smooth figure-eight drift */
  var scDriftTime = 0;
  function updateAutopilot(dtMs) {
    scDriftTime += dtMs * 0.0004;
    // Gentle figure-eight / lissajous pattern
    scWaypointX = 0.5 + 0.22 * Math.sin(scDriftTime * 1.0);
    scWaypointY = 0.5 + 0.22 * Math.sin(scDriftTime * 1.7 + 0.8);
    // Slow, weighty easing
    var ease = 0.012;
    scTargetX += (scWaypointX - scTargetX) * ease;
    scTargetY += (scWaypointY - scTargetY) * ease;
  }

  /* Preset cycling */
  function updatePresetCycle(dtMs) {
    scPresetTimer += dtMs;

    if (scPhase === 'hold') {
      scFadeProgress = 0;
      if (scPresetTimer >= SC_HOLD_DURATION) {
        scPhase = 'fade';
        scPresetTimer = 0;
      }
    } else {
      // Fading
      var raw = scPresetTimer / SC_FADE_DURATION;
      if (raw >= 1) {
        // Fade complete — advance to next preset
        scCurrentIdx = (scCurrentIdx + 1) % SC_PRESETS.length;
        scFadeProgress = 0;
        scPhase = 'hold';
        scPresetTimer = 0;
      } else {
        // Smooth ease (smoothstep)
        scFadeProgress = raw * raw * (3 - 2 * raw);
      }
    }
  }

  /* Showcase background */
  function updateScBg(bp) {
    var bR = bp.baseBg[0], bG = bp.baseBg[1], bB = bp.baseBg[2];
    var tR = bp.tint[0],   tG = bp.tint[1],   tB = bp.tint[2];

    var sim = 0.03 + 0.02 * Math.sin(scRTime * 0.4) + 0.01 * Math.sin(scRTime * 1.1);
    for (var b = 0; b < scBlobs.length; b++) {
      var bl = scBlobs[b];
      var coeff = (sim > bl.aud) ? bl.sUp : bl.sDn;
      bl.aud += coeff * (sim - bl.aud);
    }
    scRTime += 1 / 60;

    var gBase = 0;
    for (b = 0; b < scBlobs.length; b++) gBase += scBlobs[b].aud * scBlobs[b].int;
    gBase = (gBase / scBlobs.length) * 0.4;

    var imgData = scBgCtx.createImageData(BG_RES, BG_RES);
    var d = imgData.data;
    var cx = scSprings[0].x, cy = scSprings[0].y;

    for (var py = 0; py < BG_RES; py++) {
      var ny = py / (BG_RES - 1);
      for (var px = 0; px < BG_RES; px++) {
        var nx = px / (BG_RES - 1);
        var inf = gBase;

        for (b = 0; b < scBlobs.length; b++) {
          var bl2 = scBlobs[b];
          var bx = cx + (bl2.bx - 0.5) + bl2.wr * Math.sin(scRTime * bl2.wsx + bl2.wpx);
          var by = cy + (bl2.by - 0.5) + bl2.wr * Math.cos(scRTime * bl2.wsy + bl2.wpy);
          var dx = nx - bx, dy = ny - by;
          var dSq = dx * dx + dy * dy;
          var rSq = bl2.rad * bl2.rad;
          if (dSq < rSq) {
            var t = dSq / rSq;
            inf += (1 - t * t * (3 - 2 * t)) * bl2.aud * bl2.int;
          }
        }

        if (inf < 0.06) inf = 0.06;
        if (inf > 1) inf = 1;
        var idx = (py * BG_RES + px) * 4;
        d[idx]     = bR + (tR - bR) * inf;
        d[idx + 1] = bG + (tG - bG) * inf;
        d[idx + 2] = bB + (tB - bB) * inf;
        d[idx + 3] = 255;
      }
    }
    scBgCtx.putImageData(imgData, 0, 0);
  }

  /* Showcase draw */
  function drawShowcase(bp, glowImg) {
    var s = scPadSize;
    var ws = s / REF_SIZE;
    var half = GLOW_RES / 2;

    scCtx.save();
    scCtx.scale(scDpr, scDpr);
    scCtx.clearRect(0, 0, s, s);

    scCtx.imageSmoothingEnabled = true;
    scCtx.imageSmoothingQuality = 'high';
    scCtx.drawImage(scBgCanvas, 0, 0, s, s);

    for (var i = 4; i >= 0; i--) {
      var sp = scSprings[i + 1];
      var px = sp.x * s;
      var py = sp.y * s;
      var layerSize = GLOW_SIZES[i] * ws;
      var drawScale = layerSize / GLOW_RES;
      var scaleX = 1, scaleY = 1;
      var offX = 0, offY = 0, rot = 0;
      var opacity = GLOW_OPAC[i];

      var speed = Math.sqrt(sp.vx * sp.vx + sp.vy * sp.vy);
      if (speed > 1e-4) {
        rot = Math.atan2(sp.vy, sp.vx);
        var sf = 1 - Math.exp(-speed * 8);
        var sm = 1 + i * 0.3;
        scaleX = 1 + sf * (1.2 + sm);
        scaleY = 1 / (1 + sf * (0.5 + i * 0.1));
        var oa = -sf * (15 + i * 8);
        offX = Math.cos(rot) * oa;
        offY = Math.sin(rot) * oa;
      }

      // Breathing
      var phase = scBreatheTime + i * 0.3;
      var bSc = 1 + 0.08 * Math.sin(phase);
      var bOp = 0.85 + 0.15 * (0.5 + 0.5 * Math.sin(phase));
      var bb = scBreatheBlend;
      var inv = 1 - bb;
      scaleX = scaleX * inv + bSc * bb;
      scaleY = scaleY * inv + bSc * bb;
      opacity = opacity * inv + (GLOW_OPAC[i] * bOp) * bb;
      rot *= inv;
      offX *= inv;
      offY *= inv;

      scCtx.save();
      scCtx.globalAlpha = opacity;
      scCtx.translate(px + offX, py + offY);
      scCtx.rotate(rot);
      scCtx.scale(drawScale * scaleX, drawScale * scaleY);
      scCtx.drawImage(glowImg, -half, -half);
      scCtx.restore();
    }

    // Cursor dot
    scCtx.globalAlpha = 1;
    var cX = scSprings[0].x * s;
    var cY = scSprings[0].y * s;
    var cR = 9 * ws;
    var cc = bp.cursor;
    scCtx.fillStyle = 'rgb(' + cc[0] + ',' + cc[1] + ',' + cc[2] + ')';
    scCtx.beginPath();
    scCtx.arc(cX, cY, cR, 0, Math.PI * 2);
    scCtx.fill();

    scCtx.restore();
  }

  /* Showcase loop */
  function scLoop(time) {
    if (!scAnimating) return;

    if (!scLastTime) scLastTime = time;
    var dtMs = Math.min(time - scLastTime, 33.33);
    var dt = dtMs / 16.67;
    scLastTime = time;

    updateAutopilot(dtMs);
    updatePresetCycle(dtMs);

    // Springs
    stepSpring(scSprings[0], scTargetX, scTargetY, dt);
    for (var i = 1; i < scSprings.length; i++) {
      stepSpring(scSprings[i], scSprings[0].x, scSprings[0].y, dt);
    }

    // Breathing (always on for showcase)
    scBreatheTime += 0.025;
    scBreatheBlend = Math.min(1, scBreatheBlend + 0.008);

    // Get blended preset
    var bp = getBlendedPreset();
    var glowImg = buildBlendedGlow(bp);

    updateScBg(bp);
    drawShowcase(bp, glowImg);
    requestAnimationFrame(scLoop);
  }

  /* ═══════════════════════════════════════════════
     LAUNCH
     ═══════════════════════════════════════════════ */

  function initAll() {
    init();
    initShowcase();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();
